/*
 * @LastEditors: Jacky
 * @LastEditTime: 2023-04-06 17:07:32
 * @FilePath: /mojito-xy-interface/src/components/Menu/MenuMobile.tsx
 * Copyright (c) 2023 by Jacky, All Rights Reserved.
 */
import React, { useState, useEffect } from "react";
import styled from "styled-components";
import { Drawer } from "rsuite";
import MenuList from "./config";
import { Arrow } from "./arrow";
import Row from "components/Row";
import { StatusTag } from "./index";

const Imgs = {
  logo: require("../../assets/images/logo.svg").default,
  menu: require("../../assets/images/menu.svg").default,
  close: require("../../assets/images/close.svg").default,
};

const WrapperMobile = styled.div`
  width: 100%;
  height: 60px;
  background: white;
  padding: 0 24px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  border-bottom: 1px solid rgba(115, 126, 141, 0.16);
`;

const LogoMobile = styled.img`
  height: 36px;
  object-fit: cover;
  margin-left: 20px;
`;

const ImgMenu = styled.img`
  height: 24px;
  object-fit: cover;
`;

const DrawerItemWrapper = styled.div`
  border-bottom: 1px solid rgba(115, 126, 141, 0.16);
`;

const DrawerItem = styled.div<{ border?: boolean }>`
  height: 64px;
  padding: 0 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: ${({ border }) =>
    border ? "1px solid rgba(115, 126, 141, 0.16)" : "none"};
`;

const Title = styled.div`
  font-size: 16px;
  color: #01142a;
`;

const SubText = styled.div`
  font-size: 12px;
  color: #666666;
  margin-top: 5px;
`;

const ArrowWrapper = styled.div<{ color?: string; deg?: string }>`
  color: ${({ color }) => color ?? "#01142A"};
  transform: rotate(${({ deg }) => deg ?? "0deg"});
`;

const CeilWrapper = styled.div<{ isLast?: boolean }>`
  height: 60px;
  padding: 0 20px;
  display: flex;
  align-items: center;
  margin-bottom: ${({ isLast }) => (isLast ? "10px" : "0")};
`;

const ImgCeil = styled.img`
  height: 40px;
  width: 40px;
  margin-right: 12px;
`;

const MenuMobile: React.FC = (props) => {
  const [open, setOpen] = useState(false);
  const [openList, setOpenList] = useState<boolean[]>(
    new Array(MenuList.length + 1).fill(false)
  );

  useEffect(() => {
    if (open) {
      window.scrollTo(0, 0);
    }
  }, [open]);

  const renderCeil = (data: any, isLast: boolean, index: number) => {
    return (
      <CeilWrapper key={index} isLast={isLast}>
        <ImgCeil src={data?.icon} alt="icon" />
        <div>
          <Row>
            <Title>{data?.label}</Title>
            {data.status ? (
              <StatusTag color={data.status?.color}>
                {data.status?.text}
              </StatusTag>
            ) : null}
          </Row>
          <SubText>{data?.intro}</SubText>
        </div>
      </CeilWrapper>
    );
  };

  return (
    <WrapperMobile>
      <ImgMenu
        src={open ? Imgs.close : Imgs.menu}
        onClick={() => setOpen(!open)}
      />
      <LogoMobile src={Imgs.logo} />
      <Drawer placement={"right"} open={open} onClose={() => setOpen(false)}>
        {MenuList.map((data, index) => {
          if (!data.items) {
            return (
              <a href={data.href} target="_blank" rel="noreferrer">
                <DrawerItem key={index} border>
                  <Title>{data.label}</Title>
                  <ArrowWrapper deg="270deg">
                    <Arrow />
                  </ArrowWrapper>
                </DrawerItem>
              </a>
            );
          }
          return (
            <DrawerItemWrapper>
              <DrawerItem
                key={index}
                onClick={() => {
                  const nowOpen = openList;
                  nowOpen[index] = !nowOpen[index];
                  setOpenList([...nowOpen]);
                }}
              >
                <Title>{data.label === "..." ? "More" : data.label}</Title>
                <ArrowWrapper
                  color={openList[index] ? "#14D89D" : "#01142A"}
                  deg={openList[index] ? "180deg" : "0"}
                >
                  <Arrow />
                </ArrowWrapper>
              </DrawerItem>
              {openList[index] &&
                data.items.map((item: any, index: number) => {
                  return renderCeil(
                    item,
                    data?.items && data.items?.length - 1 === index
                      ? true
                      : false,
                    index
                  );
                })}
            </DrawerItemWrapper>
          );
        })}
      </Drawer>
    </WrapperMobile>
  );
};

export default MenuMobile;
